import { displayAds } from "./display"
import { initializeResponsiveAds } from "./initialize"
import { googletag } from "./shared"
import { adStatuses } from "./status"
import { ADS_BY_SIZE } from "./sizes"

let initialViewportSize = window.innerWidth

const ensureAllContainersArePopulated = () => {
  // Resizing the viewport may mean some ad containers become present
  // and need to be populated, so we check for those and initialize them
  initializeResponsiveAds()
  displayAds()
}

const scaleResponsiveAds = () => {
  const afterResize = window.innerWidth
  const slotsToRefresh = []
  const RESPONSIVE_ADS = ADS_BY_SIZE.responsive

  Object.keys(RESPONSIVE_ADS).forEach((key) => {
    const ad = RESPONSIVE_ADS[key]
    const status = adStatuses.responsive[key]

    if (ad.sizeMapping) {
      const breakpoints = ad.sizeMapping.map((sizeMapping) => sizeMapping[0][0])
      const hitBreakpoint = breakpoints.find(
        (breakpoint) =>
          (initialViewportSize < breakpoint && afterResize >= breakpoint) ||
          (initialViewportSize >= breakpoint && afterResize < breakpoint)
      )

      if (hitBreakpoint) {
        slotsToRefresh.push(status.slot)
      }
    }
  })

  if (slotsToRefresh.length > 0) {
    initialViewportSize = afterResize
    googletag.pubads().refresh(slotsToRefresh)
  }
}

const onResize = () => {
  ensureAllContainersArePopulated()
  scaleResponsiveAds()
}

if (window.addEventListener) {
  window.addEventListener("resize", onResize)
} else if (window.attachEvent) {
  window.attachEvent("onresize", onResize)
}
